import { css } from "@emotion/react";
import * as commonStyles from "../../../commonStyles";

export const container = css`
    background: #467c6f;
    padding: 24px;
    color: #fff;
    box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.25);

    .trpr__primary-layout-itinerary-items[data-min-width~="650"] & {
        padding: 36px;
    }
`;

export const header = css`
    display: grid;
    row-gap: 16px;
    margin-bottom: 16px;

    .trpr__primary-layout-itinerary-items[data-min-width~="650"] & {
        grid-template-columns: minmax(0, 1fr) auto;
        column-gap: 16px;
        align-items: center;
    }
`;

export const title = css`
    margin: 0;
    font-size: 24px;
    line-height: 36px;
    color: inherit;
    font-family: "Lexend Deca", sans-serif;
    text-transform: none;
`;

export const subTitle = css`
    display: flex;
    align-items: center;

    i {
        opacity: 0.5;
        font-size: 18px;
        margin: 0 8px 0 0;
    }

    span {
        font-size: 13px;
        line-height: 20px;
    }

    .trpr__primary-layout-itinerary-items[data-min-width~="650"] & {
        flex-direction: row-reverse;

        i {
            margin: 0 0 0 8px;
            font-size: 24px;
        }

        span {
            font-size: 15px;
            line-height: 24px;
        }
    }
`;

export const content = css`
    font-size: 13px;
    line-height: 20px;
    font-weight: 400;
    margin-bottom: 24px;

    strong {
        font-weight: 600;
        color: inherit;
    }

    p {
        font-weight: inherit;
        font-size: inherit;
        line-height: inherit;
        margin-bottom: 0;

        & + p {
            margin-top: 1em;
        }
    }

    a {
        color: inherit !important;
    }

    .trpr__primary-layout-itinerary-items[data-min-width~="650"] & {
        font-size: 15px;
        line-height: 24px;
    }
`;

export const carousel = ({ isSingleCarousel }) => css`
    .slider .slide {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: transparent;
    }

    img {
        border-radius: 4px;
        max-height: 400px;
        max-width: 100%;
        object-fit: cover;
        width: auto !important;
    }

    .control-dots,
    .control-arrow {
        position: static !important;
    }

    .carousel {
        display: grid;
        row-gap: 24px;
        grid-template-columns: 0 auto 1fr auto 1fr auto 0;
        grid-template-areas:
            "carousel carousel carousel carousel carousel carousel carousel"
            "void1 left void2 dots void3 right void4";
    }

    .slider-wrapper {
        grid-area: carousel;
    }
    .control-dots {
        padding: 0 16px;
        grid-area: dots;
        margin: 0;
        display: flex;
        align-items: center;

        .dot {
            outline: 0 !important;
            margin: 0 !important;
            box-shadow: none !important;
            position: relative;

            &:after {
                position: absolute;
                top: -16px;
                right: -4px;
                bottom: -16px;
                left: -4px;
                content: " ";
            }

            &:not(:last-of-type) {
                margin: 0 4px 0 0 !important;
            }

            &:not(.selected) {
                opacity: 0.5 !important;
            }
        }
    }
    .control-prev,
    .control-next {
        grid-area: right;
        height: 36px !important;
        width: 36px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        font-size: 24px !important;
        background: rgba(255, 255, 255, 0.25) !important;
        border-radius: 4px !important;
        opacity: 1 !important;
        color: #ffffff !important;

        &::before {
            ${commonStyles.icomoonIcon}
            border: 0 !important;
            content: "${commonStyles.icomoonVars.forward}" !important;
        }
    }
    .control-prev {
        grid-area: left;
        &::before {
            content: "${commonStyles.icomoonVars.back}" !important;
        }
    }

    .trpr__primary-layout-itinerary-items[data-min-width~="650"] & {
        .carousel {
            grid-template-columns: 1fr auto 0 auto 0 auto 1fr;
        }
    }

    ${isSingleCarousel &&
        `
        .carousel {
            row-gap: 0;
        }

        .control-dots,
        .control-arrow {
            display: none !important;
        }
    `}
`;
